import React from 'react';
import exclamation from '../../Images/Common/exclamation.svg';
import './style.scss';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import useCreditContext from '../../hooks/useCreditContext';

const NotEnoughCredit = ({
  setOpenModal,
  availableCredits,
  requiredCredits,
}) => {
  const {
    credits: { free: freeCredits = 0, paid: paidCredits = 0 },
  } = useCreditContext();

  const totalCredits = freeCredits + paidCredits;

  return (
    <div className="not_enough_credit">
      <div className="credit_image">
        <img src={exclamation} alt="Exclamation mark" />
      </div>
      <h2 className="credit_title">Not enough credit</h2>
      <p className="credit_text">
        You only have {totalCredits} credits in your balance. This generation
        requires {requiredCredits} credits.
      </p>
      <p className="credit_text_upgrade">
        Upgrade your plan to get more credits,
      </p>
      <Button className="continue_btn_line">
        <Link to="/subscription?redirectby=generate">Buy more credits</Link>
      </Button>
      <p className="select_images" onClick={() => setOpenModal(false)}>
        or select fewer images.
      </p>
    </div>
  );
};

export default NotEnoughCredit;
